const getQuantityCountTooltip = (
  selectedTicketCurrentQuantity: number,
  totalAmountOfTicketsSelected: number,
  remainingTickets: number,
  maxTicketsPerTransaction: number
) => {
  if (selectedTicketCurrentQuantity === remainingTickets) {
    return remainingTickets === 1
      ? 'There is only 1 ticket remaining.'
      : `There are only ${remainingTickets} tickets remaining.`;
  }

  if (totalAmountOfTicketsSelected === maxTicketsPerTransaction) {
    return maxTicketsPerTransaction === 1
      ? 'This event does not allow purchasing more than 1 ticket.'
      : `This event does not allow purchasing more than ${maxTicketsPerTransaction} tickets`;
  }

  return null;
};

export default getQuantityCountTooltip;
